import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LeafletModule } from '@asymmetrik/ngx-leaflet/dist/leaflet/leaflet.module';
import { MiniMapaComponent } from './mini-mapa.component';

@NgModule({
  imports: [
    CommonModule,
    LeafletModule.forRoot()
  ],
  declarations: [
    MiniMapaComponent,
],
  exports: [MiniMapaComponent],
  bootstrap: [MiniMapaComponent]
})
export class MiniMapaModule { }



// WEBPACK FOOTER //
// ./src/app/main/components/mini-mapa/mini-mapa.module.ts